import * as React from "react";
const SvgFiRrGrill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grill_svg__a)">
      <path
        fill="#062147"
        d="M23.339 7.129A2.98 2.98 0 0 0 20.999 6H3c-6.653 1.04-.635 9.791 2.834 11.341l-1.78 5.343a1.001 1.001 0 0 0 1.9.632l1.7-5.116c1.075.407 2.202.662 3.347.757V23a1 1 0 1 0 2 0v-4.043c1.145-.096 2.27-.35 3.345-.758l1.706 5.117a1 1 0 1 0 1.9-.632l-1.781-5.345c2.839-1.489 7.452-6.939 5.169-10.21m-1.367 2.115C19.488 19.5 4.506 19.5 2.026 9.244A.993.993 0 0 1 3 8h18a.994.994 0 0 1 .972 1.244M11 3V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0m4 0V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0M7 3V1a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grill_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrill;
